import { IFullPlanDetail, IFullPlanDetailPPO } from "../../interfaces/api";
import { Link } from "react-router-dom";
import CompareStickRecommend from "./CompareStickRecommend.component";
import AccessDemand from "../Compare/AccessDemand.component";

const AllPlansHeaderRecommend = ({
  plans,
}: {
  plans: IFullPlanDetail[] | IFullPlanDetailPPO[];
}) => {
  if (plans.length < 1) {
    return null;
  }

  return (
    <div className="grid-x margin-0 hide-for-small-only">
      <h3
        className="cell blue-stroke text-center"
        style={{
          fontWeight: 600,
          fontSize: "39px",
          paddingBottom: "16px",
        }}
      >
        Here are the best plans for you
      </h3>
      <Link
        className="cell"
        to={{
          pathname: "/get-recommendations/coverage-year",
        }}
        style={{ textDecoration: "none" }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            color: "#1B54C2",
            fontSize: 18,
            lineHeight: "120%",
            textDecoration: "underline",
            paddingBottom: "27px",
            fontWeight: 500,
          }}
        >
          Start Over
        </div>
      </Link>
      {plans.length === 3 ? (
        <div className="grid-x">
          <div className="cell small-3">
            <AccessDemand />
          </div>
          <div className="cell small-3">
            <CompareStickRecommend data={plans[0]} />
          </div>
          <div className="cell small-3">
            <CompareStickRecommend data={plans[1]} />
          </div>
          <div className="cell small-3">
            <CompareStickRecommend data={plans[2]} />
          </div>
        </div>
      ) : (
        <div className="grid-x">
          <div className="cell small-4">
            <AccessDemand />
          </div>
          <div className="cell small-4">
            <CompareStickRecommend data={plans[0]} />
          </div>
          <div className="cell small-4">
            <CompareStickRecommend data={plans[1]} />
          </div>
        </div>
      )}
    </div>
  );
};

export default AllPlansHeaderRecommend;
